export default Object.freeze(['menu_Menu', 'menu_MeatballProfileLayout', 'profileMenu_MeatballProfileLayout']);
